import queryString from 'query-string';
import {
  all,
  call,
  put,
  select,
  spawn,
  take,
  takeLatest,
} from 'redux-saga/effects';

import { createStandaloneToast, theme } from '@frontend/legacy-components';

import teamService from 'services/teamService';

import { PAGE_REQUEST } from 'store/app/actions';
import * as SESSION from 'store/session';

import { sendInvitesModal, sendInvites, types } from './actions';

const { toast } = createStandaloneToast({ theme });

function* watchLocationChange() {
  for (;;) {
    const { payload } = yield take(PAGE_REQUEST);
    if (
      payload.location.search &&
      queryString.parse(payload.location.search).invite_modal_open === 'true'
    ) {
      yield put(sendInvitesModal.open());
    }
  }
}

function* watchSendInvites(action) {
  try {
    const groupId = yield select(SESSION.selectors.getGroupId);
    const { emailAddresses } = action.payload;
    yield all(
      emailAddresses.map((emailAddress) =>
        call(sendInvite, { emailAddress, groupId }),
      ),
    );
    yield put(sendInvites.success());
  } catch (e) {
    yield put(sendInvites.error(e));
  }
}

function* sendInvite({ emailAddress, groupId }) {
  try {
    yield teamService.inviteTeamMember(groupId, { email: emailAddress });
  } catch (e) {
    toast({
      title: `Failed to invite ${emailAddress}.`,
      status: 'error',
      description: e.message,
    });
    throw e;
  }
}

export default function* root() {
  yield spawn(watchLocationChange);
  yield takeLatest(types.SEND_INVITES_REQUEST, watchSendInvites);
}
